import React, { useState, useMemo } from 'react';
import { Divider, Flex } from '@withjoy/joykit';
import { ListingWithPricing } from '@apps/accommodations/AccommodationsConsole.types';
import { AccommodationsConsoleState } from '@apps/accommodations/AccommodationsConsole.types';
import { ListingEntry } from './components/ListingEntry';

type Coordinates = {
  latitude: number;
  longitude: number;
};
interface ListingsPanelProps {
  hidePanel?: boolean;
  isLoadingPrices: boolean;
  listings: Array<ListingWithPricing>;
  venueCoordinates: Coordinates;
  occupancies: AccommodationsConsoleState['occupancies'];
  noOfNights: number;
}

const Container: React.FC<{ hide?: boolean }> = ({ hide, children }) => {
  return (
    <Flex height="fit-content" flexDirection="column" display={hide ? 'none' : 'flex'} paddingLeft={6} paddingY={8} paddingRight={8} rowGap={8}>
      {children}
    </Flex>
  );
};

const ListingsPanel = (props: ListingsPanelProps) => {
  const { hidePanel, isLoadingPrices, listings, venueCoordinates, occupancies, noOfNights } = props;

  const [page] = useState(0);

  const listingsToRender = useMemo(() => {
    return listings.slice(0, (page + 1) * 10);
  }, [listings, page]);

  return (
    <Container hide={hidePanel}>
      {listingsToRender.map((listing, idx) => {
        return (
          <React.Fragment key={listing.id}>
            <ListingEntry occupancies={occupancies} venueCoordinates={venueCoordinates} listing={listing} isLoadingPrices={isLoadingPrices} noOfNights={noOfNights} />
            {idx < listings.length - 1 && <Divider />}
          </React.Fragment>
        );
      })}
    </Container>
  );
};

ListingsPanel.Skeleton = () => {
  return (
    <Container>
      <ListingEntry.Skeleton />
      <Divider />
      <ListingEntry.Skeleton />
      <Divider />
      <ListingEntry.Skeleton />
      <Divider />
      <ListingEntry.Skeleton />
    </Container>
  );
};

export { ListingsPanel };
